var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 16 16",
    width: "16pt",
    height: "16pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_RUQAMchPMjTYlaqoPz7UFjjxXFCmVBdG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_RUQAMchPMjTYlaqoPz7UFjjxXFCmVBdG)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    style: {
      fill: "rgb(0,0,0)"
    },
    fillOpacity: 0
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 3 7 L 3 5 L 5 5 L 5 3 L 7 3 L 7 1 L 9 1 L 9 7 L 15 7 L 15 9 L 9 9 L 9 15 L 7 15 L 7 13 L 5 13 L 5 11 L 5 11 L 3 11 L 3 9 L 1 9 L 1 7 L 1 7 L 1 7 L 1 7 L 3 7 Z ",
    fill: "rgb(255,255,255)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.b98eaaf12e849cb04f8eee5194709b4f.svg";
export { ForwardRef as ReactComponent };